import React from 'react'
import './subTituloRes.scss'

const SubTituloSimp = ({nombre}) => {
  return (
    <div className='tituloSimple col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12'>
      <h6>{nombre}</h6>
    </div>
  )
}

export default SubTituloSimp
